import { SortCriterion } from '@shinetools/lumen-react'

import { BillsTableSortCriterion } from '../types/billsTableSortCriterion'
import { isBillsTableSortKey } from './isBillsTableSortKey'

export const isBillsTableSortCriterion = (criterion: SortCriterion | undefined): criterion is BillsTableSortCriterion =>
  criterion !== undefined && isBillsTableSortKey(criterion.key)
